export default __webpack_public_path__ + "static/media/union_pay.9b26e7ee.svg";